import React from "react";
import { ChevronDown, ChevronUp, Plus, Trash2 } from "lucide-react";

export default function CalculatieSectionTable({
  title,
  description,
  open,
  onToggle,
  columns,
  rows,
  subtotal,
  onAdd,
  emptyState,
}) {
  return (
    <section className="border border-slate-200 bg-white">
      <button
        type="button"
        onClick={onToggle}
        className="flex w-full items-center justify-between gap-3 border-b border-slate-200 px-4 py-3 text-left"
      >
        <div>
          <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
          {description ? <p className="mt-1 text-sm text-slate-600">{description}</p> : null}
        </div>
        {open ? <ChevronUp size={18} className="text-slate-500" /> : <ChevronDown size={18} className="text-slate-500" />}
      </button>

      {open ? (
        <div className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full border-collapse text-sm">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
                  {columns.map((column) => (
                    <th
                      key={column.key}
                      className={`px-3 py-2 font-semibold ${column.headerClassName || "text-left"}`}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((row, index) => (
                    <tr key={row.key || index} className="border-b border-slate-100 align-top">
                      {columns.map((column) => {
                        const cell = row.cells[column.key];
                        return (
                          <td
                            key={column.key}
                            className={`px-3 py-2 ${column.cellClassName || ""}`}
                          >
                            {cell}
                          </td>
                        );
                      })}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length} className="px-4 py-8 text-center text-sm text-slate-500">
                      {emptyState}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 bg-slate-50 px-4 py-3">
            <button
              type="button"
              onClick={onAdd}
              className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-slate-700 transition hover:bg-slate-100"
            >
              <Plus size={16} />
              Regel
            </button>

            <div className="flex flex-wrap items-center gap-6 text-sm">
              <SubtotalItem label="Kost" value={subtotal.cost} />
              <SubtotalItem label="Verkoop" value={subtotal.sell} />
              <SubtotalItem label="Marge" value={subtotal.margin} tone={subtotal.margin < 0 ? "text-rose-700" : "text-emerald-700"} />
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
}

export function NumberCell({ value, onChange, placeholder = "0,00", step = "0.01", min = "0", align = "right" }) {
  return (
    <input
      type="number"
      min={min}
      step={step}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={`w-full rounded-sm border border-slate-200 bg-white px-2 py-1.5 text-sm text-slate-900 outline-none transition focus:border-slate-400 ${align === "right" ? "text-right" : "text-left"}`}
    />
  );
}

export function TextCell({ value, onChange, placeholder = "" }) {
  return (
    <input
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="w-full rounded-sm border border-slate-200 bg-white px-2 py-1.5 text-sm text-slate-900 outline-none transition focus:border-slate-400"
    />
  );
}

export function ActionCell({ onRemove }) {
  return (
    <button
      type="button"
      onClick={onRemove}
      className="inline-flex h-8 w-8 items-center justify-center rounded-sm border border-rose-200 bg-rose-50 text-rose-600 transition hover:bg-rose-100"
      title="Verwijderen"
    >
      <Trash2 size={15} />
    </button>
  );
}

function SubtotalItem({ label, value, tone = "text-slate-900" }) {
  return (
    <div className="text-right">
      <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{label}</p>
      <p className={`text-sm font-semibold ${tone}`}>€ {Number(value || 0).toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
    </div>
  );
}
